// extracted by mini-css-extract-plugin
export default {"dayStock":"index_dayStock_gv2ur","title":"index_title_OalkU clearfix","list":"index_list_PrZBx","pic":"index_pic_4cUJF","link":"index_link_c7aPv","trans":"index_trans_loR7A"};